import axios, {AxiosResponse} from 'axios';
import {TimeSeriesEntry} from './TimeSeriesEntry';
import {DateRange} from '../stores/TimeIntervalStore';
import {handleError} from './errorHandling';
import {convertCamelCaseToSnakeCase} from '../utility/ApiParamConversion';
import {KPI} from '../kpi';

export interface TimeSeriesRequest {
    channel: string;
    campaignId: string;
    kpi: KPI;
    interval: DateRange;
}

export interface ChannelTimeSeriesRequest {
    channel: string;
    kpi: KPI;
    interval: DateRange;
}

export function getHourlyCampaignDataSummary(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`campaign/${channel}/hourly/${convertCamelCaseToSnakeCase(kpi)}/summary`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfCampaignChannelDiagramDataFailed'));
}

export function getHourlyCampaignData(request: TimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`campaign/${channel}/hourly/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfCampaignDiagramFailed'));
}

export function getDailyCampaignDataSummary(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`campaign/${channel}/daily/${convertCamelCaseToSnakeCase(kpi)}/summary`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfCampaignChannelDiagramDataFailed'));
}

export function getDailyCampaignData(request: TimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`campaign/${channel}/daily/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfCampaignDiagramFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/CampaignAPI.ts